import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { authActions, usuarioAction, logAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import { Button, Container, Row, Col, Card, CardBody, UncontrolledTooltip, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NavBar from '../_components/navbar';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faPen, faTrash, faClock, faUser, faIdBadge, faMobileAlt, faSearch, faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { ModalLogUsuario } from '../log/';

const Usuario = (props) => {

    const [term, setTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit] = useState(12);
    const [modalLog, setModalLog] = useState(false);
    const [usuarioLog, setUsuarioLog] = useState('');

    // Delete validation state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);

    const toggleLog = () => setModalLog(!modalLog);
    const { log } = props.log;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { usuario } = props.usuario;

    useEffect(() => {
        dispatch(usuarioAction.getUsuario(true));
    }, []);

    const handleChange = event => {
        setTerm(event.target.value);
        setPage(1);
    };

    const confirmDelete = (id) => {
        setUserToDelete(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = () => {
        if (userToDelete) {
            dispatch(usuarioAction.deleteUsuarioById(userToDelete, true));
            setDeleteModalOpen(false);
            setUserToDelete(null);
        }
    };

    const handleClickHistory = (event, id, usuarioName) => {
        if (id) {
            setUsuarioLog(usuarioName);
            dispatch(logAction.getLogUsuario(id));
            toggleLog();
        }
    };

    const getUserTypeLabel = (type) => {
        switch (type) {
            case 'A': return 'ADMINISTRADOR';
            case 'I': return 'INSEMINADOR';
            case 'G': return 'GESTOR';
            case 'E': return 'EXPORTAÇÃO';
            case 'P': return 'PREFEITURA';
            case 'U': return 'USUÁRIO';
            default: return 'DESCONHECIDO';
        }
    };

    const getUserTypeColor = (type) => {
        switch (type) {
            case 'A': return 'danger';
            case 'G': return 'warning';
            case 'U': return 'info';
            default: return 'secondary';
        }
    };

    // Client-side Filtering
    const filteredUsers = usuario ? usuario.filter((item) => {
        if (!term) return true;
        const lowerTerm = term.toLowerCase();
        return item.nome.toLowerCase().includes(lowerTerm) ||
            (item.login && item.login.toLowerCase().includes(lowerTerm));
    }) : [];

    // Client-side Pagination
    const totalItems = filteredUsers.length;
    const totalPages = Math.ceil(totalItems / limit);
    const paginatedUsers = filteredUsers.slice((page - 1) * limit, page * limit);

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Usuários</h2>
                        <p className="text-muted mb-0">Gerencie o acesso e permissões do sistema</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ maxWidth: '300px' }}>
                            <Input
                                id="term"
                                placeholder="Buscar por nome ou login..."
                                value={term}
                                onChange={handleChange}
                                style={{
                                    paddingLeft: '40px',
                                    borderRadius: '50px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                    height: '45px'
                                }}
                            />
                            <FontAwesomeIcon
                                icon={faSearch}
                                className="text-muted position-absolute"
                                style={{ left: '15px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                            {term && (
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="text-muted position-absolute cursor-pointer"
                                    onClick={() => { setTerm(''); setPage(1); }}
                                    style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                />
                            )}
                        </div>

                        {authActions.isGestor() && (
                            <>
                                <Button
                                    id="btnNovo"
                                    color="primary"
                                    className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                                    style={{ borderRadius: '50px', fontWeight: '600', height: '45px' }}
                                    onClick={() => navigate("/usuario")}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                                    <span className="text-nowrap">Novo Usuário</span>
                                </Button>
                                <UncontrolledTooltip placement="bottom" target="btnNovo">
                                    Adicionar novo usuário
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                </div>

                {/* Grid Section */}
                {paginatedUsers.length > 0 ? (
                    <>
                        <Row>
                            {paginatedUsers.map((item) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={item.id}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column">

                                            <div className="d-flex align-items-center mb-4">
                                                <div className="d-flex justify-content-center align-items-center bg-light text-primary rounded-circle mr-3"
                                                    style={{ width: '50px', height: '50px', backgroundColor: 'var(--primary-light)' }}>
                                                    <FontAwesomeIcon icon={faUser} size="lg" />
                                                </div>
                                                <div style={{ overflow: 'hidden' }}>
                                                    <h5 className="mb-1 font-weight-bold text-dark text-truncate" title={item.nome}>
                                                        {item.nome.toUpperCase()}
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faIdBadge} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate" title={item.login}>
                                                        {item.login}
                                                    </span>

                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faIdBadge} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate">
                                                        {getUserTypeLabel(item.tipo)}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faMobileAlt} className="text-muted" />
                                                    </div>
                                                    <span>
                                                        {item.listaDispositivos ? `${item.listaDispositivos.length} dispositivo(s)` : '0 dispositivos'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
                                                <Button
                                                    color="link"
                                                    className="text-decoration-none p-0 text-muted d-flex align-items-center"
                                                    onClick={(event) => handleClickHistory(event, item.id, item.nome)}
                                                    title="Histórico"
                                                >
                                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mr-2" style={{ width: '32px', height: '32px' }}>
                                                        <FontAwesomeIcon icon={faClock} size="sm" />
                                                    </div>
                                                    <span className="small font-weight-bold">Histórico</span>
                                                </Button>

                                                <div className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0 }}
                                                        component='a'
                                                        href={`/usuario/${item.id}`}
                                                        title="Editar"
                                                    >
                                                        <FontAwesomeIcon icon={faPen} size="sm" />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: '#e03131' }}
                                                        onClick={() => confirmDelete(item.id)}
                                                        title="Excluir"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} size="sm" />
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faUser} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhum registro encontrado</h4>
                            <p className="text-muted">Não encontramos usuários com os filtros atuais.</p>
                            {term && (
                                <Button color="primary" outline onClick={() => { setTerm(''); setPage(1); }} className="mt-2 rounded-pill px-4">
                                    Limpar Filtros
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>

            <ModalLogUsuario toggle={toggleLog} modal={modalLog} log={log} usuario={usuarioLog} />

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                <ModalHeader toggle={() => setDeleteModalOpen(false)} className="border-0 pb-0"></ModalHeader>
                <ModalBody className="text-center pb-4">
                    <div className="mb-3 text-danger bg-light-danger d-inline-block rounded-circle p-3" style={{ backgroundColor: '#ffebee' }}>
                        <FontAwesomeIcon icon={faTrash} size="2x" />
                    </div>
                    <h4 className="mb-2 font-weight-bold">Excluir Usuário</h4>
                    <p className="text-muted mb-4">Tem certeza que deseja excluir este usuário? Esta ação não pode ser desfeita.</p>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <Button color="light" onClick={() => setDeleteModalOpen(false)} className="mr-2 rounded-pill px-4 font-weight-bold">Cancelar</Button>
                    <Button color="danger" onClick={handleDelete} className="rounded-pill px-4 font-weight-bold shadow-sm">Confirmar Exclusão</Button>
                </ModalFooter>
            </Modal>

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );

};

const mapStateToProps = (state) => {
    return state;
};

const connectedUsuarioPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Usuario));
export { connectedUsuarioPage as Usuario };